import { render, staticRenderFns } from "./GirlsCampCovidLabels.vue?vue&type=template&id=0cc3878d&"
import script from "./GirlsCampCovidLabels.vue?vue&type=script&lang=js&"
export * from "./GirlsCampCovidLabels.vue?vue&type=script&lang=js&"
import style0 from "./GirlsCampCovidLabels.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports